import React from 'react'

const Title = ({ adminButton, title = 'Legislation' }) => (
  <div>
    <div className='layout-width-constraint'>
      <div className='ma0 pl6 pt8 pb6 bg-white db w-100 f3 fw7'>{title}</div>
    </div>
    <div className='dn'>
      {adminButton}
    </div>
  </div>
)

export default Title
